<template>
  <v-data-table
    :headers="headers"
    :items="adminPayoutPending"
    sort-by="id"
    :loading="tableLoader"
    loading-text="Fetching Payout Requests..."
    no-data-text="There are no pending payout requests."
    class="mb-12 elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Pending Payout Requests</v-toolbar-title>
      </v-toolbar>
    </template>

    <template v-slot:item.timestampCreated="{ item }">
      {{ item.timestampCreated | timestampToDate }}
    </template>

    <template v-slot:item.user.emailAddress="{ item }">
      <router-link :to="`/user/${item.id}`">
        {{ item.user.emailAddress }}
      </router-link>
    </template>

    <template v-slot:item.amount="{ item }">
      {{ item.amount | numberToMoney }}
    </template>

    <template v-slot:item.actions="{ item }">
      <!-- Record Payment Modal -->
      <v-dialog
        v-model="recordPaymentDialog"
        max-width="600px"
      >
        <PayoutPaidConfirm
          v-on:dialogClose="recordPaymentDialog = false"
        ></PayoutPaidConfirm>
      </v-dialog>

      <v-icon
        @click="recordPayment(item)"
      >
        mdi-cash-check
      </v-icon>
    </template>

  </v-data-table>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import PayoutPaidConfirm from './PayoutPaidConfirm.vue'

  export default {
    name: 'PendingPayoutList',

    components: {
      PayoutPaidConfirm
    },

    computed: {
      ...mapGetters([
        'adminPayoutPending'
      ])
    },

    data: () => ({
      tableLoader: true,
      recordPaymentDialog: false,

      search: '',

      // Mapping datatable.
      headers: [
        {
          text: 'Requested',
          value: 'timestampCreated',
          align: 'start'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Email',
          value: 'user.emailAddress',
          sortable: true
        },
        {
          text: 'Method',
          value: 'method',
          sortable: true
        },
        {
          text: 'Amount Requested',
          value: 'amount',
          align: 'right'
        },
        {
          text: 'Mark As Paid',
          value: 'actions',
          align: 'end',
          sortable: true
        }
      ]
    }),

    methods: {
      ...mapActions([
        'getPendingStatus'
      ]),

      ...mapMutations([
        'setPayoutRequest'
      ]),

      recordPayment: function (payoutRequest) {
        this.setPayoutRequest(payoutRequest)
        this.recordPaymentDialog = true
      }
    },

    created() {
      this.getPendingStatus().then(() => {
        this.tableLoader = false
      })
    }
  }
</script>
